import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fileSize',
  standalone: false
})
export class FileSizePipe implements PipeTransform {

  private readonly units = ['B', 'KB', 'MB', 'GB'];

  transform(bytes: number): string {
    if (!bytes) {
      return '0 B';
    }

    let value = bytes;
    let unitIndex = 0;
    while (value >= 1024 && unitIndex < this.units.length - 1) {
      value /= 1024;
      unitIndex++;
    }

    const decimals = unitIndex === 0 ? 0 : 1;
    return `${value.toFixed(decimals)} ${this.units[unitIndex]}`;
  }
}
